<div class="charts-line-chart" *ngIf="chart">
    <ngx-charts-line-chart [legend]="legend" [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel" [xAxis]="xAxis" [yAxis]="yAxis" [timeline]="timeline" [results]="chart"
        [autoScale]="autoScale">
    </ngx-charts-line-chart>
</div>
<div class="no-data" *ngIf="!chart">
    <h2>No Data</h2>
</div>